import { Button, styled } from "@mui/material";

const PrimaryButton = (props) => {
  return (
    <CustomButton {...props}>
      <span>{props.children}</span>
    </CustomButton>
  );
};

const CustomButton = styled(Button)(
  ({ theme, variant, loading, fontSize }) => ({
    mt: "1vh",
    background: variant === "contained" ? theme.palette.primary.main : theme.palette.background.light,
    textTransform: "capitalize",
    transition: "all 0.35s ease-in-out",
    position: "relative",
    overflow: "hidden",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: 0,
      height: "100%",
      backgroundColor: theme.palette.primary.hover,
      transition: "all 0.35s ease-in-out",
    },
    "&:hover:before": {
      width: "100%",
    },
    span: {
      position: loading ? "" : "relative",
      zIndex: 1,
      fontWeight: "bold",
      fontSize: fontSize || "1.6vh",
      color:
        variant === "outlined"
          ? theme.palette.primary.main
          : theme.palette.text.dark,
    },
    "&:hover": {
      span: {
        color: theme.palette.text.dark,
        transition: "all 0.35s ease-in-out",
      },
    },
  })
);

export default PrimaryButton;
